import React from "react";
import RecommendationSetManager from "./RecommendationSetManager";

export default function ExploreMoreDestinations() {
  return <RecommendationSetManager section="explore-more-destinations" title="Explore More Destinations" maxSlots={4} textField="name" textLabel="Destination name" detailField="experience_count" detailLabel="Experience count" />;
}
